import { http } from '../helpers/http'
import { buildFindAllUrl } from './shared.service'

const exportAction = (eventId, actionId, mapUrl, format) => {
  return http.post(
    `/event/${eventId}/action/${actionId}/export`,
    {
      printUrl: mapUrl,
      format: format
    },
    {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/pdf'
      }
    }
  )
}

const find = (eventId, actionId) => {
  return http.get(`/event/${eventId}/action/${actionId}`)
}

const findAll = (filters) => {
  let url = '/actions'
  if (filters) {
    url = buildFindAllUrl(url, filters)
  }
  return http.get(url)
}

const findEventActions = ({ eventId, filters, ...params }) => {
  params.filters = JSON.stringify(filters)
  return http.get(`/event/${eventId}/actions`, { params })
}
const create = (eventId, action) => {
  const cleanAction = {
    nature: action.nature.id || null,
    recipient:
      (action.recipient !== null && action.recipient.id !== 'other'
        ? action.recipient.id
        : null) || null,
    origin:
      (action.origin !== null && action.origin.id !== 'other'
        ? action.origin.id
        : null) || null,
    label: action.label,
    startingDate: action.startingDate || null,
    endingDate: action.endingDate || null,
    requestDate: action.requestDate || null,
    coordinates: action.coordinates || null,
    otherOrigin: action.otherOrigin || null,
    otherRecipient: action.otherRecipient || null,
    description: action.description || null,
    moreInformation: action.moreInformation || null
  }

  return http.post(`/event/${eventId}/actions`, cleanAction)
}

const update = (eventId, actionId, action) => {
  console.log('COORDINATES PATCH', action.coordinates)
  const cleanAction = {
    nature: action.nature.id || null,
    recipient:
      (action.recipient.id !== 'other' ? action.recipient.id : null) || null,
    origin: (action.origin.id !== 'other' ? action.origin.id : null) || null,
    label: action.label,
    startingDate: action.startingDate || null,
    endingDate: action.endingDate || null,
    requestDate: action.requestDate || null,
    coordinates: action.coordinates || null,
    otherOrigin: action.otherOrigin || null,
    otherRecipient: action.otherRecipient || null,
    description: action.description || null,
    moreInformation: action.moreInformation || null
  }

  return http.patch(`/event/${eventId}/action/${actionId}`, cleanAction)
}

const deleteAction = (eventId, actionId) => {
  return http.delete(`/event/${eventId}/action/${actionId}`)
}

const removeFile = (eventId, actionId, fileId) => {
  return http.delete(`event/${eventId}/action/${actionId}/attachment/${fileId}`)
}

const findHistory = (eventId, actionId) => {
  return http.get(`/event/${eventId}/action/${actionId}/history`)
}

export const actionService = {
  find,
  findAll,
  findEventActions,
  create,
  deleteAction,
  update,
  removeFile,
  findHistory,
  exportAction
}
